/* eslint-disable @typescript-eslint/no-explicit-any */
import { Suspense, useState, FC, useEffect, useRef } from 'react';
import { LocaleUtils } from 'react-day-picker';
import { StyledCalendarWrapperDiv } from './CalendarWrapper.styles';
import {
  Button,
  Calendar,
  DateObjectType,
  getLocalizedDate,
  getValueFromDate,
  Messages,
  useWindowSize,
} from '@marriott/mi-ui-library';
import { useConditionalPageContextADF } from '../../hooks';
import {
  CALENDAR_MAX_ALLOWED_DAYS,
  VARIATION_DESKTOP,
  SHORT_WEEK_DAYS,
  LONG_WEEK_DAYS_NAME,
  SHORT_MONTH_NAME,
  NUMBER_OF_MONTH,
  DATE_FORMAT_YEAR_MONTH_DAY,
  NO_CHECK_IN_DATE_ERROR,
  DATE_FORMAT_MM_DD_VALUE,
  POINTS_PER_QUANTITY,
  LOWEST_AVERAGE_RATE,
  ADF_CONTINUE_CLICK_TRACK,
  hardCodedAllLocale,
  AVG_TAB,
  TOTAL_RATE,
} from '../../constants';
import { FocusedInputType, CalendarWrapperProps } from './CalendarWrapper.types';
import { setLanguageLocalization, CustomizeRenderDay, fetchSpecificRates } from './CalendarWrapper.helper';
import { useCheckBreakpoint } from '../../hooks';
import clsx from 'clsx';
import moment from 'moment';
import { validateAvailabilityRequest } from '../../lib/organisms/SearchForm/utils/Helpers';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { formatNumberByLocale } from '../../utils/src/utils';
import {
  getExchangeConversionRate,
  getFormattedDateByLocale,
  updateDataLayerOnInteractions,
} from '../../modules/utils';
import {
  fetchCurrencyToLocale,
  getRateConversionFactor,
  getLocaleFromDocument,
  convertArabicToEnglishNumbers,
  convertHindiToEnglishNumbers,
  getPageDirectionFromDocument,
} from '../../utils/src/helper';
import {
  JP_LOCALE,
  KR_LOCALE,
  DE_LOCALE,
  US_LOCALE,
  PT_BR_LOCALE,
  ES_LOCALE,
  AR_LOCALE,
  HI_LOCALE,
} from '../../modules/constants';
import { AlertMessageBodyProps } from './../../organisms/AvailabilityCalendar/AvailabilityCalendar.types';
import { identifyTypeOfMandatoryFee } from '../../modules/utils/ratesHelper';
import { useSearchFormStore } from '../../modules/store/searchFormStore';

export const CalendarWrapper: FC<CalendarWrapperProps> = props => {
  const {
    weekdays,
    weekdaysLong,
    monthsShort,
    adfButtonText,
    months,
    notAvailableForCheckInText,
    rateUnavailableText,
    totalPerRoom,
    forLabel,
    night,
    nights,
    firstDayOfWeek,
    ratesUnavailableMobile,
    lowPriceIndicator,
    thousandLabel,
    tenThousandLabel,
    millionLabel,
    pointsLabel,
    yearSearchLabel,
    currencyLabel,
    resortLabel,
    feeLabel,
    destinationAmenityLabel,
    surchargeTooltipHeadingLabel,
    allRatesIncludeLabel,
    includesLabel,
    dailyLabel,
    allRatesAdditionalLabel,
    perNight,
    totalLabel,
    localDateFormat,
    adfSelectionSummaryFormat,
    tourismMarketingFeeLabel,
  } = props.jsonContent;
  const [monthChange, setMonthChange] = useState(true);
  const [feeTitle, setFeeTitle] = useState('');
  const [isLACountyFee, setIsLACountyFee] = useState(false);
  const pageContext = useConditionalPageContextADF();
  const {
    headersData,
    currentLocale,
    NEXT_PUBLIC_PRE_PROCESSING_RELATIVE_ADF_URL,
    resolvedUrl,
    query,
    datalayerParams,
    sessionData,
    isBulgariDomain,
  } = pageContext;

  let smallerDevicesCheck = false;
  const windowSize = useWindowSize().width;
  if (windowSize && windowSize < 767) {
    smallerDevicesCheck = true;
  } else {
    smallerDevicesCheck = false;
  }
  const returnApplicableAlert = props?.returnApplicableAlert;
  const formData = props.formData;
  const adfData = props.adfData;

  const selectedTab = props.selectedTab;
  const onMonthChange = (e: any) => {
    setMonthChange(true);
    props.onMonthChange(e);
  };
  const defaultMonthDate = (() => {
    const parsed = moment(props.defaultMonthDate);
    if (!parsed.isValid()) {
      return new Date();
    }
    return getLocaleFromDocument() === AR_LOCALE || getLocaleFromDocument() === HI_LOCALE
      ? new Date(parsed.toISOString())
      : new Date(parsed.format());
  })();
  const inventoryData = props.inventoryData;
  const isPointsSelected = props.isPointsSelected;
  const [calendarFromDate, setCalendarFromDate] = useState<any>();
  const [calendarEndDate, setCalendarEndDate] = useState<any>();
  const currentCurrency = props.currentCurrency;
  const numberOfDays = props.numberOfDays;
  const sessionDataObj = pageContext?.sessionData?.data
    ? pageContext?.sessionData?.data
    : pageContext?.sessionData?.cacheData?.data;
  const sessionID =
    sessionData?.sessionToken ??
    sessionData?.data?.sessionToken ??
    sessionData?.cacheData?.key ??
    sessionData?.cacheData?.data?.sessionToken;

  const currentConverSionRateArr = sessionDataObj?.AriesSearch?.currentConversionRate;
  const conversionFactorRate = getRateConversionFactor(currentConverSionRateArr, props.fromCurrency) ?? 1;
  const availabilityRequestVO = sessionDataObj?.AriesSearch?.searchCriteria?.availabilityRequestVO;
  const propertyId = sessionDataObj?.AriesReservation?.propertyId;
  const search_fusionsearchid = sessionDataObj?.AriesCommon?.search_fusionsearchid;
  const includeTaxesAndFees = sessionDataObj?.AriesSearch?.searchCriteria?.showFullPrice === 'true' ? true : false;
  const [useRewardsPoints, setUseRewardsPoints] = useState(availabilityRequestVO?.rewardsRedemption);
  const [roomsAndGuests, setRoomsAndGuests] = useState({
    numberOfRooms: availabilityRequestVO?.numRooms,
    numberOfAdults: availabilityRequestVO?.numAdultsPerRoom,
    numberOfChildren: availabilityRequestVO?.numChildrenPerRoom,
    childrenAges: availabilityRequestVO?.childrenAges,
  });
  const [specialRates, setSpecialRates] = useState({
    clusterCode: availabilityRequestVO?.clusterCode,
    corporateCode: availabilityRequestVO?.corporateCode,
    groupCode: availabilityRequestVO?.groupCode,
  });

  const totalMandatoryFeesvalue =
    getExchangeConversionRate(props?.ersManFees || 0, conversionFactorRate ? conversionFactorRate : 1) ?? 0;
  const mandatoryFeesValue = Math.floor(totalMandatoryFeesvalue) ?? 0;
  const dateRange = props.dateRange;
  const [alertMessage, setAlertMessage] = useState<AlertMessageBodyProps>({});
  /*
   * converting the currentLocale value (EX:'en_US' to 'en-US')
   * to meet the exact locale of commaSeperator func.
   */
  const currentLocal = currentLocale?.replace('_', '-');
  const disabledDatesVal = useRef<Date[]>([]);
  const [totalAmountAsPerSelection, setTotalAmountAsPerSelection] = useState(0);
  const START_DATE = 'startDate';
  const [focusedState, setFocusedState] = useState<FocusedInputType>(START_DATE);
  const isMobile = useCheckBreakpoint('viewportM');
  const isViewportL = useCheckBreakpoint('viewportL');
  const TOTAL_WEEK_DAYS_COUNT = 7;
  const TOTAL_MONTH_COUNT = 12;
  const isArabic = getLocaleFromDocument() === AR_LOCALE;
  const isHindi = getLocaleFromDocument() === HI_LOCALE;
  const isRTLEnabled = getPageDirectionFromDocument() === 'rtl';

  // Zustand: update local state from SearchForm store when baseline submit happens
  const searchCTAClicked = useSearchFormStore((state: any) => state?.searchCTAClicked);
  const storeUsePoints = useSearchFormStore((state: any) => state?.usePoints);
  const storeSpecialRates = useSearchFormStore((state: any) => state?.specialRates);
  const storeRoomsAndGuests = useSearchFormStore((state: any) => state?.roomsAndGuests);
  /*
   * Setting up the toCurrency Value based on selectedCurrency
   */

  const updateCalendarData = (data: any) => {
    const formValues = data?.formValues;
    setUseRewardsPoints(formValues?.usePoints?.value);
    setSpecialRates({
      clusterCode: formValues?.specialRates?.clusterCode,
      corporateCode:
        formValues?.specialRates?.clusterCode?.toLowerCase() === 'corp'
          ? formValues?.specialRates?.corporateCode?.trim()
          : '',
      groupCode:
        formValues?.specialRates?.clusterCode?.toLowerCase() === 'group'
          ? (formValues?.specialRates?.groupCode ?? formValues?.specialRates?.corporateCode)?.trim()
          : '',
    });
    setRoomsAndGuests({
      numberOfRooms: formValues?.roomsAndGuests?.roomsCount,
      numberOfAdults: formValues?.roomsAndGuests?.adultsCount,
      numberOfChildren: formValues?.roomsAndGuests?.childrenCount,
      childrenAges: formValues?.roomsAndGuests?.childrenAges,
    });
  };

  eventUtil.on('availabilityCalendarSearchFormData', data => {
    updateCalendarData(data);
  });

  useEffect(() => {
    if (searchCTAClicked) {
      const formValues = {
        usePoints: {
          value: storeUsePoints?.rewardsRedemption,
        },
        specialRates: {
          clusterCode: storeSpecialRates?.specialRateCode,
          corporateCode: storeSpecialRates?.corporateCode,
          groupCode: storeSpecialRates?.groupCode,
        },
        roomsAndGuests: {
          roomsCount: storeRoomsAndGuests?.numRooms,
          adultsCount: storeRoomsAndGuests?.numAdultsPerRoom,
          childrenCount: storeRoomsAndGuests?.numChildrenPerRoom,
          childrenAges: storeRoomsAndGuests?.childrenAges,
        },
      };
      updateCalendarData({ formValues });
    }
  }, [searchCTAClicked, storeUsePoints, storeSpecialRates, storeRoomsAndGuests]);

  let shortWeekdays = weekdays?.split(',');
  // set default weekdays if i18 weekdays value are invalid
  if (shortWeekdays?.length !== TOTAL_WEEK_DAYS_COUNT) {
    shortWeekdays = SHORT_WEEK_DAYS;
  }
  let weeksdaysShort = weekdays?.split(',');
  // set default weekdays if i18 weekdays value are invalid
  if (weeksdaysShort?.length !== TOTAL_WEEK_DAYS_COUNT) {
    weeksdaysShort = SHORT_WEEK_DAYS;
  }

  let weekdaysLongName = weekdaysLong?.split(',');
  if (weekdaysLongName?.length !== TOTAL_WEEK_DAYS_COUNT) {
    weekdaysLongName = LONG_WEEK_DAYS_NAME;
  }

  let monthsValue = months?.split(',');
  // set default month if i18 months value are invalid
  if (monthsValue?.length !== TOTAL_MONTH_COUNT) {
    monthsValue = LocaleUtils.getMonths();
  }

  let monthsShortValue = monthsShort?.split(',');
  // set default month if i18 months value are invalid
  if (monthsShortValue?.length !== TOTAL_MONTH_COUNT) {
    monthsShortValue = SHORT_MONTH_NAME;
  }

  const clearDateSelection = (): void => {
    //clear the date selection if user double click on checkin date
    setCalendarFromDate(null);
    setCalendarEndDate(null);
  };

  // handler to set fromDate in the formValues
  const setDateHandler = (startDate: DateObjectType | null): void => {
    const from = startDate ?? undefined;

    const end = startDate?.clone()?.add(Number(numberOfDays), 'days');

    setCalendarFromDate(from);
    setCalendarEndDate(end);
    let ratesPerSelection = 0;
    adfData?.calendarSearchByProperty?.edges?.forEach((edge: any) => {
      const isEdgeRelatedToSelectedDateEdge = isCurrentDateEdge(
        moment(edge?.node?.startDate).format(DATE_FORMAT_YEAR_MONTH_DAY),
        moment(edge?.node?.endDate).format(DATE_FORMAT_YEAR_MONTH_DAY),
        moment(from).format(DATE_FORMAT_YEAR_MONTH_DAY)
      ); //To verify if the edge is either start date or in between start and end dates in oder to fetch the corresponding rates block

      if ((isPointsSelected || props.isRedemption) && isEdgeRelatedToSelectedDateEdge) {
        ratesPerSelection = edge?.node?.rateModes?.pointsPerQuantity?.points;
      }

      if (!isPointsSelected && !props.isRedemption && isEdgeRelatedToSelectedDateEdge) {
        const ratesArray = edge?.node?.rateModes?.totalRate?.amount;
        ratesPerSelection = ratesArray?.amount / Math.pow(10, ratesArray?.decimalPoint);
      }
    });
    if (disabledDatesVal.current?.toString()?.includes(new Date(moment(from)?.format()).toDateString()?.toString())) {
      setTotalAmountAsPerSelection(0);
    } else {
      if (isPointsSelected || props.isRedemption) {
        const ratesSelected = Math.floor(ratesPerSelection);
        setTotalAmountAsPerSelection(ratesSelected);
      } else {
        const ratesSelected = Math.floor(ratesPerSelection * conversionFactorRate);
        const finalRatesPostConversion = ratesSelected
          ? ratesSelected + (totalMandatoryFeesvalue > 0 ? totalMandatoryFeesvalue * numberOfDays : 0)
          : 0;
        setTotalAmountAsPerSelection(finalRatesPostConversion);
      }
    }
    // update date in page context

    // if from and end date are same then remove end date and keep focus on end date
    if (from?.isSame(calendarFromDate)) {
      // if user click on checkin date while focus on end date input
      setFocusedState(START_DATE);
      clearDateSelection();
    }
  };
  useEffect(() => {
    setCalendarFromDate(null);
    setCalendarEndDate(null);
  }, [
    selectedTab,
    JSON.stringify(props.formData?.dates),
    JSON.stringify(props.formData?.roomsAndGuests),
    JSON.stringify(props.formData?.specialRates),
    JSON.stringify(props.formData?.usePoints?.value),
  ]);

  useEffect(() => {
    fetchDisabledDates();
  }, [props.adfData]);
  useEffect(() => {
    /**
     * Event to capture the basic information from phoenixADFShopSearchProductsByProperty/phoenixShopADFSearchProductsByProperty UXL call
     */
    eventUtil.on('sendMandatoryFeeDescription', data => {
      //to display resort or destination fee label after checking description type

      const {
        isLACountyFee: isLACountyFeeFlag,
        isResort,
        isDestinationFee,
        isMarketingFee,
      } = identifyTypeOfMandatoryFee(data);

      setIsLACountyFee(isLACountyFeeFlag);

      const toolTipTitle = isResort
        ? resortLabel + ' ' + feeLabel
        : isLACountyFeeFlag
        ? surchargeTooltipHeadingLabel
        : isMarketingFee
        ? tourismMarketingFeeLabel
        : isDestinationFee
        ? destinationAmenityLabel + ' ' + feeLabel
        : '';
      setFeeTitle(toolTipTitle);
    });
    return (): void => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      eventUtil.remove('hotelHeaderDataBasicInformation', () => {});
    };
  }, []);

  // set locale for dates
  setLanguageLocalization(monthsShortValue, monthsValue, weekdaysLongName, weeksdaysShort);

  const isCurrentDateEdge = (startDate: string, endDate: string, formattedDay: string): boolean => {
    return moment(formattedDay).isBetween(startDate, endDate, undefined, '[]');
  };

  // Function to calculate the last day of the Calendar month
  const getLastDayOfMonth = () => {
    const firstDayOfMonth = new Date(defaultMonthDate.getFullYear(), defaultMonthDate.getMonth(), 1);
    const firstDayOfCalendar = new Date(firstDayOfMonth.setDate(firstDayOfMonth.getDate() - firstDayOfMonth.getDay()));

    return new Date(firstDayOfCalendar.setDate(firstDayOfCalendar.getDate() + 34));
  };

  const renderDay: FC<Date> = day => {
    let renderData = {
      formData: formData,
      adfData: {},
      selectedTab: selectedTab,
      rateUnavailableText: rateUnavailableText,
      notAvailableForCheckInText: props?.isAlertMessage ? '' : notAvailableForCheckInText,
      inventoryDateData: inventoryData,
      isLowest: false,
    };
    const rateBlock = isPointsSelected || props.isRedemption ? POINTS_PER_QUANTITY : LOWEST_AVERAGE_RATE;
    let MIN_RATE = Number.MAX_SAFE_INTEGER;
    const lastDayOfMonth = getLastDayOfMonth();
    adfData?.calendarSearchByProperty?.edges?.forEach((edge: any) => {
      const rateAmount = fetchSpecificRates(edge?.node?.rateModes, rateBlock, conversionFactorRate);
      const startDate = new Date(edge?.node?.basicInformation?.startDate || edge?.node?.startDate);
      const startDateUTC = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000);
      /**
       * check if rate is less than the minimum rate value
       * and the start date should also be less than the last day of the calendar month
       */
      if (rateAmount && rateAmount < MIN_RATE && startDateUTC <= lastDayOfMonth) {
        MIN_RATE = rateAmount;
      }
    });

    adfData?.calendarSearchByProperty?.edges?.forEach((edge: any) => {
      const newRateAmount = fetchSpecificRates(edge?.node?.rateModes, rateBlock, conversionFactorRate);
      const isLowest = newRateAmount === MIN_RATE;
      const startDate = edge?.node?.startDate;
      const endDate = edge?.node?.endDate;
      const formattedDay = isArabic
        ? convertArabicToEnglishNumbers(getValueFromDate(moment(day), DATE_FORMAT_YEAR_MONTH_DAY))
        : isHindi
        ? convertHindiToEnglishNumbers(getValueFromDate(moment(day), DATE_FORMAT_YEAR_MONTH_DAY))
        : getValueFromDate(moment(day), DATE_FORMAT_YEAR_MONTH_DAY);
      if (isCurrentDateEdge(startDate, endDate, formattedDay)) {
        renderData = {
          formData: formData,
          adfData: edge,
          selectedTab: selectedTab,
          rateUnavailableText: rateUnavailableText,
          notAvailableForCheckInText: props?.isAlertMessage ? '' : notAvailableForCheckInText,
          inventoryDateData: inventoryData,
          isLowest: isLowest,
        };
      }
    });

    const compactFormatLiteral = {
      millionLabel,
      thousandLabel,
      tenThousandLabel,
    };

    return CustomizeRenderDay(
      day,
      isMobile,
      renderData,
      props?.isDataLoading,
      conversionFactorRate,
      isViewportL,
      currentLocal,
      smallerDevicesCheck,
      isPointsSelected,
      props.isRedemption,
      lowPriceIndicator,
      compactFormatLiteral,
      currentCurrency,
      totalMandatoryFeesvalue,
      numberOfDays,
      props?.isAlertMessage ? true : false
    );
  };
  // function to fetch disabled dates
  const fetchDisabledDates = () => {
    const startDate = new Date(moment(dateRange[0]).subtract(1, 'days').format(DATE_FORMAT_YEAR_MONTH_DAY));

    const endDate = new Date(moment(dateRange[1]).add(1, 'days').format(DATE_FORMAT_YEAR_MONTH_DAY));

    const filteredDates = [];

    // The below variable is added to disable all the dates in the Calendar when an error message appears
    const disableAllDates = [
      {
        before: new Date(9999, 11, 31), // A far future date
        after: new Date(0, 0, 1), // A far past date
      },
    ];
    for (
      let currentDate = new Date(startDate);
      currentDate <= endDate;
      currentDate.setDate(currentDate.getDate() + 1)
    ) {
      let dateFound = false;
      // Check if the current date is in the dataArray
      if (adfData && adfData.calendarSearchByProperty && adfData.calendarSearchByProperty.edges) {
        for (const data of adfData.calendarSearchByProperty.edges) {
          const startDate = data?.node?.startDate;
          const endDate = data?.node?.endDate;
          const formattedDate = moment(currentDate).format(DATE_FORMAT_YEAR_MONTH_DAY);
          const edge = data;
          const rateBlock =
            isPointsSelected || props.isRedemption
              ? POINTS_PER_QUANTITY
              : selectedTab === AVG_TAB
              ? LOWEST_AVERAGE_RATE
              : TOTAL_RATE;

          const specificRate = fetchSpecificRates(
            edge?.node?.rateModes,
            rateBlock,
            conversionFactorRate,
            rateBlock === LOWEST_AVERAGE_RATE ? mandatoryFeesValue : mandatoryFeesValue * numberOfDays
          );
          if (isCurrentDateEdge(startDate, endDate, formattedDate) && specificRate) {
            dateFound = true;
            break;
          }
        }
      }

      // If the date is not in the dataArray and falls within the range, add it to missingDates
      if (!dateFound && isDateInRange(currentDate, startDate, endDate) && !smallerDevicesCheck) {
        filteredDates.push(new Date(currentDate));
      } else if (smallerDevicesCheck && moment(currentDate).isAfter(inventoryData)) {
        //for mobile devices, if date is outside kDate only then disabled cells
        filteredDates.push(new Date(currentDate));
      }
    }
    disabledDatesVal.current = filteredDates;

    // If error is present then disabling all the dates of the Calendar
    if (props?.isAlertMessage) {
      return disableAllDates;
    }
    return filteredDates;
  };

  const updateDisabledNavButtonTabIndex = () => {
    const navButtons = document.querySelectorAll('.DayPicker-NavButton');
    navButtons.forEach(button => {
      const navButtonElement = button as HTMLElement;
      const isInteractionDisabled = navButtonElement.classList.contains('DayPicker-NavButton--interactionDisabled');
      if (isInteractionDisabled) {
        navButtonElement.setAttribute('tabindex', '-1');
        navButtonElement.setAttribute('aria-disabled', 'true');
        if (document?.activeElement === navButtonElement) {
          navButtonElement.blur();
        }
      } else {
        navButtonElement.setAttribute('tabindex', '0');
        navButtonElement.setAttribute('aria-disabled', 'false');
      }
    });
  };

  // added this useEffect to make aria-disabled false for the dates outside the month
  useEffect(() => {
    if (monthChange) {
      updateDisabledNavButtonTabIndex();
      //since this element is from react-day-picker, need to handle it with query selector.
      const disableddays = document.querySelectorAll('.DayPicker-Day--outside');
      for (let i = 0; i < disableddays.length; i++) {
        if (disableddays[i].ariaDisabled === 'true' && !moment(disableddays[i].ariaLabel).isBefore(moment())) {
          disableddays[i].ariaDisabled = 'false';
        }
      }
      setMonthChange(false);
    }
  }, [monthChange]);
  const isDateInRange = (date: Date, startDate: Date, endDate: Date) => {
    return date >= startDate && date <= endDate;
  };

  const onSinlgeClickDateRangeSelect = (
    day: Date,
    setEndFromDatesForcefully: (startDay: Date, endDay: Date) => void
  ) => {
    setFocusedState(START_DATE);
    const fDate = moment(day).add(Number(numberOfDays), 'days');
    setEndFromDatesForcefully(day, fDate.toDate());
    setAlertMessage({});
    // }
  };

  // function to handle the continue button click and trigger an alert, if necessary
  const handleCalendarContinueButtonAction = (): any => {
    if (!calendarFromDate || calendarFromDate === null || calendarFromDate?.toString() === '') {
      const applicableAlert = returnApplicableAlert(NO_CHECK_IN_DATE_ERROR);
      if (applicableAlert) {
        setAlertMessage(applicableAlert);
      }
    } else {
      onContinueClick();
    }
  };

  const onContinueClick = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    let newSearchParams = searchParams.toString();
    if (
      adfData?.calendarSearchByProperty?.edges?.findIndex((edge: any) => {
        const startDate = edge?.node?.startDate;
        return startDate === calendarFromDate?.format(DATE_FORMAT_YEAR_MONTH_DAY);
      }) === -1
    ) {
      newSearchParams = `${searchParams.toString()}${'&unsuccessfulSell=true'}`;
      window.history.replaceState({}, headersData?.referer, decodeURIComponent(`?${newSearchParams}`));
    }
    const dates = { fromDate: calendarFromDate, toDate: calendarEndDate };
    const availabilitySearchParams = {
      isFromFlexibleDateCalendar: true,
      numberOfRooms: roomsAndGuests?.numberOfRooms,
      numberOfAdults: roomsAndGuests?.numberOfAdults,
      numberOfChildren: roomsAndGuests?.numberOfChildren,
      childrenAges: roomsAndGuests?.childrenAges,
      useRewardsPoints,
      clusterCode: specialRates?.clusterCode,
      corporateCode: '',
      groupCode: '',
      fromDate: getFormattedDateByLocale(currentLocal, dates, localDateFormat ?? DATE_FORMAT_MM_DD_VALUE).fromDateValue,
      toDate: getFormattedDateByLocale(currentLocal, dates, localDateFormat ?? DATE_FORMAT_MM_DD_VALUE).toDateValue,
    };
    // Handle special case for group cluster code
    if (specialRates?.clusterCode?.toLocaleLowerCase() === 'group') {
      availabilitySearchParams.clusterCode = 'none';
    } else {
      availabilitySearchParams.groupCode = specialRates?.groupCode?.trim();
      availabilitySearchParams.corporateCode = specialRates?.corporateCode?.trim();
    }
    const params = new URLSearchParams(Object(availabilitySearchParams));
    // Remove the incorrect parameter numberOfAdults from /validate/availabilitySearch request parameters
    if (!params.has('numAdultsPerRoom')) {
      params.set('numAdultsPerRoom', params.get('numberOfAdults') || '');
    }
    params.delete('numberOfAdults');

    params.forEach((value, key) => {
      if (
        value?.trim() === '' ||
        value === null ||
        value === undefined ||
        value?.trim() === 'undefined' ||
        value?.trim() === 'null'
      ) {
        params.delete(key);
      }
    });
    const availabilitySearchQueryString = `${params.toString()}`;

    //calling the shop app to update session on continue clicking
    const response = await validateAvailabilityRequest(
      false,
      NEXT_PUBLIC_PRE_PROCESSING_RELATIVE_ADF_URL,
      props.propertyId,
      currentCurrency,
      includeTaxesAndFees,
      props.interceptorResponse,
      props.preHeader,
      true,
      availabilitySearchQueryString,
      true,
      headersData,
      isBulgariDomain
    );

    if (response) {
      updateDataLayerOnInteractions(
        resolvedUrl,
        headersData,
        query,
        datalayerParams,
        currentLocale,
        sessionID,
        propertyId,
        search_fusionsearchid,
        isBulgariDomain,
        undefined,
        undefined,
        specialRates?.clusterCode
      );
    }
  };

  useEffect(() => {
    //Can't access this element without this selector.
    const dataPickerCaption = document.getElementsByClassName('DayPicker-Caption')[0];
    if (dataPickerCaption && dataPickerCaption.getAttribute('role') === 'heading') {
      dataPickerCaption.removeAttribute('role');
    }
  });

  return (
    <StyledCalendarWrapperDiv data-component-name="m-shop-CalendarWrapper" data-testid="shop-CalendarWrapper">
      <Suspense fallback={<div>Loading...</div>}>
        <Calendar
          startDate={calendarFromDate}
          endDate={calendarEndDate}
          focusedInput={focusedState}
          setDateHandler={setDateHandler}
          setFocusedInputHandler={(newState: FocusedInputType): void => setFocusedState(newState)}
          nightLabel={night}
          nightsLabel={nights}
          variation={VARIATION_DESKTOP}
          maxAllowedDays={CALENDAR_MAX_ALLOWED_DAYS}
          weekdays={shortWeekdays}
          months={monthsValue}
          weekdaysLong={weekdaysLongName}
          monthsShort={monthsShortValue}
          weekdaysShort={weeksdaysShort}
          firstDayOfWeek={firstDayOfWeek}
          numberOfMonths={NUMBER_OF_MONTH}
          customRenderDayCell={renderDay}
          disabledDays={fetchDisabledDates()}
          showOutsideDays={true}
          onSinlgeClickDateRangeSelect={onSinlgeClickDateRangeSelect}
          defaultMonth={defaultMonthDate}
          onMonthChange={onMonthChange}
          disableHoverToolTip={true}
          advanceMonth={true}
          enableOutsideDaysClick={false}
          locale={currentLocale}
          yearLabel={yearSearchLabel}
        />
      </Suspense>
      <div
        className={clsx(
          'd-flex',
          'justify-content-md-end',
          'px-md-5',
          'px-3',
          'py-4',
          'price-section-wrapper',
          'align-items-center',
          'justify-content-between'
        )}
      >
        <div>
          {calendarFromDate && calendarEndDate && (
            <div className={clsx('price-section', 'text-md-right', 'mr-3', 'mr-md-4')}>
              {totalAmountAsPerSelection < 1 ? (
                <div className="a-text-body t-font-s">{ratesUnavailableMobile}</div>
              ) : (
                <>
                  {isRTLEnabled ? (
                    <div>
                      <span className="t-subtitle-m currency adf-currency-value">
                        {`${totalLabel || ''} `}
                        {isPointsSelected || props.isRedemption
                          ? `${pointsLabel} `
                          : `${fetchCurrencyToLocale(currentLocal, currencyLabel, currentCurrency)} `}
                      </span>
                      <span className="t-subtitle-xl">
                        {formatNumberByLocale(Math.floor(totalAmountAsPerSelection), currentLocal)}
                      </span>
                    </div>
                  ) : (
                    <div className="t-subtitle-xl">
                      {formatNumberByLocale(Math.floor(totalAmountAsPerSelection), currentLocal)}
                      <span className="currency t-subtitle-m adf-currency-value">
                        {isPointsSelected || props.isRedemption
                          ? pointsLabel
                          : fetchCurrencyToLocale(currentLocal, currencyLabel, currentCurrency)}
                        {` ${totalLabel || ''}`}
                      </span>
                    </div>
                  )}
                  {currentLocal === hardCodedAllLocale.en &&
                    mandatoryFeesValue > 0 &&
                    !isLACountyFee &&
                    (isPointsSelected || props.isRedemption) && (
                      <div
                        className={clsx('t-font-xs', 'mandatory-fees-text-selected', 'mr-0', 'text-md-right', 'mb-1')}
                      >
                        {calendarEndDate && calendarFromDate && totalAmountAsPerSelection ? (
                          <div>
                            {`+ ${formatNumberByLocale(
                              mandatoryFeesValue,
                              currentLocal
                            )} ${currentCurrency} ${dailyLabel} ${feeTitle ? feeTitle : ''}`}
                          </div>
                        ) : null}
                      </div>
                    )}

                  <div className={clsx(isMobile ? 't-font-m' : 't-font-xs')}>
                    {isPointsSelected || props.isRedemption ? forLabel : totalPerRoom}{' '}
                    {isArabic
                      ? convertArabicToEnglishNumbers(
                          getLocalizedDate(calendarFromDate, adfSelectionSummaryFormat, currentLocal)
                        )
                      : isHindi
                      ? convertHindiToEnglishNumbers(
                          getLocalizedDate(calendarFromDate, adfSelectionSummaryFormat, currentLocal)
                        )
                      : getLocalizedDate(calendarFromDate, adfSelectionSummaryFormat, currentLocal)}
                    {currentLocale === 'pl-PL' ? ' – ' : ' - '}
                    {isArabic
                      ? convertArabicToEnglishNumbers(
                          getLocalizedDate(calendarEndDate, adfSelectionSummaryFormat, currentLocal)
                        )
                      : isHindi
                      ? convertHindiToEnglishNumbers(
                          getLocalizedDate(calendarEndDate, adfSelectionSummaryFormat, currentLocal)
                        )
                      : getLocalizedDate(calendarEndDate, adfSelectionSummaryFormat, currentLocal)}{' '}
                    ({calendarEndDate?.diff(calendarFromDate, 'days')}{' '}
                    {calendarEndDate?.diff(calendarFromDate, 'days') < 2 ? `${night}` : `${nights}`})
                  </div>
                </>
              )}
            </div>
          )}
          {currentLocal === hardCodedAllLocale.en &&
            mandatoryFeesValue > 0 &&
            !(isPointsSelected || props.isRedemption) && (
              <div className={clsx('t-font-xs', 'mandatory-fees-text-selected', 'mr-md-4', 'text-md-right')}>
                {calendarEndDate && calendarFromDate && totalAmountAsPerSelection ? (
                  <div>
                    {`${includesLabel} ${formatNumberByLocale(
                      mandatoryFeesValue,
                      currentLocal
                    )} ${currentCurrency} ${perNight} ${feeTitle ? feeTitle : ''}`}
                  </div>
                ) : (
                  <div>
                    {`${allRatesIncludeLabel}
                 ${formatNumberByLocale(mandatoryFeesValue, currentLocal)} ${currentCurrency}
                  ${perNight}
                  ${feeTitle ? feeTitle : ''}`}
                  </div>
                )}
              </div>
            )}
          {currentLocal === hardCodedAllLocale.en &&
            mandatoryFeesValue > 0 &&
            !isLACountyFee &&
            !(calendarEndDate && calendarFromDate && totalAmountAsPerSelection) &&
            (isPointsSelected || props.isRedemption) && (
              <div className={clsx('t-font-xs', 'mandatory-fees-text-selected', 'mr-md-4', 'text-md-right')}>
                {`${allRatesAdditionalLabel}
                  ${formatNumberByLocale(mandatoryFeesValue, currentLocal)} ${currentCurrency}
                  ${dailyLabel}
                  ${feeTitle ? feeTitle : ''}`}
              </div>
            )}
        </div>

        {alertMessage?.alertMessage && (
          <Messages
            className={clsx('adf-error-messages', 'pt-4')}
            messageType={alertMessage?.alertType}
            messageHeading={alertMessage?.alertHeading}
            messageText={alertMessage?.alertMessage}
            messageContentTabIndex={0}
            messageRole="alert"
          />
        )}
        <Button
          className={clsx(
            isMobile ? 'm-button-l' : 'm-button-s',
            calendarFromDate && calendarEndDate && totalAmountAsPerSelection > 1
              ? props?.isAlertMessage
                ? 'disable-continue'
                : ''
              : 'disable-continue'
          )}
          callback={handleCalendarContinueButtonAction}
          testId="con-cta"
          custom_click_track_value={ADF_CONTINUE_CLICK_TRACK}
          isDisabled={
            calendarFromDate && calendarEndDate && totalAmountAsPerSelection > 1
              ? props?.isAlertMessage
                ? true
                : false
              : true
          }
        >
          {adfButtonText}
        </Button>
      </div>
    </StyledCalendarWrapperDiv>
  );
};
